export enum Path {
  Home = "/",
  Blog = "/blog",
}
